import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import { Redirect, Link } from "react-router-dom";
import * as Tools from "../../helpers/Tools";
import * as types from "../../constants/actionTypes";
import { logUI } from "../../api/andyliticsApi";
import { cloneDeep, differenceBy } from 'lodash';
import Spinner from '../common/spinner';
import InHomeConfirmationModal from './InHomeConfirmationModal';
import { Card, Modal, Divider, DropDownWithValidation as DropDown, Typography } from "../ecosystem/";
import { InHomeMainPanel, InHomeOverviewPanel, InHomePatientInputSection, InHomeSplitLayout } from "./layout"
import { inHomeWhereErrors } from '../../constants/textConstants';
import * as msgs from "../../constants/textConstants";



const InHomeWhich = ({ serviceLocation, profileList, history, getVaccinePending, getVaccineResult, eligibleVaccines, selectedVaccines,
    setSelectedVaccines, getAvailableVaccines, selectedUsers, getPrefilledData, setSelectedUsers, screenBreakPoint, inHomeNudgeModalViewed, vaccineNudgeClicked }) => {

    //console.log('selectedUsers', selectedUsers)
   // console.log('eligibleVaccines', eligibleVaccines)
    const [selectedMonths, setSelectedMonths] = useState([]);
    const [disabledMonths, setDisabledMonths] = useState([]);
    const [vaccineSelected, setVaccineSelected] = useState(null);
    const [showWarning, setShowWarning] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showVaccineErrors, setShowVaccineErrors] = useState(false);
    const [showContent, setShowContent] = useState(true);
    const [showMembers, setShowMembers] = useState(false);
    const [checkAllMRN, setCheckAllMRN] = useState([]);
    const [isNudge, setIsNudge] = useState(false);
    const [nudgeModal, setNudgeModal] = useState(false);
    const [isAddVaccineClicked, setIsAddVaccineClicked] = useState(false);
    const [userList, setUserList] = useState([]);
    const [isAllUsersChecked, setisAllUsersChecked] = useState(false);
    const [activeAccordionIndex, setActiveAccordionIndex] = useState(-1);

    useEffect(() => {
        logUI(`MBHWeb.UI.InHomeSchedulingWhich.Displayed`, new Date(), Tools.getURLPath());
        //getAvailableVaccines();       
        //initShowContentMRN();
        if (history?.location?.yesAddVaccineClicked) {
            setIsAddVaccineClicked(true)
        }
        populatePreCheckedRecipientSelect();

    }, []);

    const populatePreCheckedRecipientSelect = () => {
        let userList = createUserList();
        if (selectedUsers?.length) {
            userList = userList.filter(u => selectedUsers.filter(s => s.mrn === u.mrn).length === 0);

        }
        setUserList(userList);
    }
    const createUserList = () => {
        let allUsers = profileList.map((prof, i) => {
            let inHomeProfile = {
                patientName: prof.patient?.PatientName,
                label: prof.patient?.PatientName,
                value: prof.patient?.PatientName,
                firstName: prof.patient?.FirstName,
                lastName: prof.patient?.LastName,
                dob: prof.patient?.DOB,
                mrn: prof.patient?.AMRN,
                eligibleVaccines: [],
                eligible: false,
            }
            let vaxFeature = prof.features.find((feature) => feature.key === "inHomeVaccination")
            if (vaxFeature) {
                inHomeProfile.eligible = true;
                inHomeProfile.eligibleVaccines = vaxFeature.vaccinations;
            }
            return inHomeProfile;
        });

        return allUsers?.filter(user => user.eligible == true && user.eligibleVaccines?.length > 0);
    }


    useEffect(() => {

        if (!getVaccinePending && getVaccineResult && getVaccineResult.success) {

            if (eligibleVaccines?.length > 0 && (vaccineSelected === null || vaccineSelected.length === 0)) {
                setVaccineSelected(eligibleVaccines);
                //initContentMRN();               
            }
            else {
                setVaccineSelected(selectedVaccines);
            }
        }
    }, [getVaccineResult])


    //handle  showing of vaccine errors
    useEffect(() => {
        if (getVaccineResult && !getVaccineResult.success && getVaccineResult.errorMsg) {
            setShowVaccineErrors(true);
        }
    }, [getVaccineResult])


    const isNextButtonDisabled = () => {
        return vaccineSelected && !vaccineSelected.find((user) => !!user?.vaccines_groups?.find(group => !!group?.vaccines?.find(vaccines => !!vaccines?.isChecked)));
    }


    const handlePopup = () => {
        setShowModal(!showModal)
    }

    const isEnableNudge = () => {
        
        let userWithAtleastOneLeftoutVaccine = vaccineSelected && vaccineSelected.find((user) => user?.vaccines_groups?.find(group => group?.vaccines?.some(vaccine => vaccine.isChecked == false)));
        let enableNudge = false;

        if (userWithAtleastOneLeftoutVaccine) {
            vaccineSelected && vaccineSelected.forEach((user) => {
                let unCheckedList = user?.vaccines_groups?.filter(group => { return group?.vaccines?.some(vaccine => vaccine.isChecked == false) })
                if (unCheckedList?.length > 0) {
                    if (hasMultipleFluOptions(user?.vaccines_groups)) {
                        let unCheckedNonFluVaccinesExists = unCheckedList.some(vaccines_groups => { return vaccines_groups?.group?.toLowerCase() !== 'influenza' });
                        let unCheckedFluVaccines = unCheckedList.find(vaccines_groups => { return vaccines_groups?.group?.toLowerCase() === 'influenza' });
                        let isOneFluChecked = unCheckedFluVaccines && unCheckedFluVaccines.vaccines.some(vaccine => { return vaccine?.isChecked === true });
                        if (unCheckedNonFluVaccinesExists) {
                            // If user has a non flu vaccine unchecked show nudge
                            enableNudge = true;
                        } else if (!isOneFluChecked) {
                            // If user does not have at least one flu vaccine checked show nudge
                            enableNudge = true;
                        }
                    } else {
                        // If user does not have multiple flu options then means non flu vaccine is not checked so show nudge
                        enableNudge = true;
                    }
                }
            });
        }

        //if the user has left out atleast one vaccine that belongs to the influenze group, consider that as having selected all vaccines. Do not show Nudge modal in this case
        return enableNudge;

    }
    
    const onClickNext = () => {
        logUI(`MBHWeb.UI.InHomeSchedulingWhich.Next.Clicked`, new Date(), Tools.getURLPath());

        //dtermine if we are adding any new family members (proxies).
        //If yes, update the 'selectedUsers' state and redirect to the Insurance screen
        let tempNewlySelectedUsers = userList.filter((u, i) => {
            return u.isChecked
        });

       // console.log("tempSelectedUsers...", tempNewlySelectedUsers);

       if (tempNewlySelectedUsers?.length > 0 )
       {
            let newUsersToAdd = differenceBy(tempNewlySelectedUsers, selectedUsers, 'mrn');
            //console.log("new users to add", newUsersToAdd);
            setSelectedUsers([...selectedUsers, ...newUsersToAdd]);
            history.push("/inhomeschedule/s31");
        }


        if (!isNextButtonDisabled()) {
            setSelectedVaccines(vaccineSelected);
            if (isUserBelowEighteen()) {
                setShowModal(true);
                return;
            }
            if (nudgeModal) {
                history.push("/inhomeschedule/s5")
            }
            if (isEnableNudge() && !vaccineNudgeClicked) {
                setIsNudge(true);
            } else {
                history.push("/inhomeschedule/s5")
            }
        } else {
            setShowWarning(true);
        }
    }


    const onClickPrev = () => {
        logUI(`MBHWeb.UI.InHomeSchedulingWhich.Previous.Clicked`, new Date(), Tools.getURLPath());
        setSelectedVaccines(vaccineSelected);
        history.push("/inhomeschedule/s31")
    }

    const handleCheck = (userIndex, vgIndex, vaccineIndex, isChecked) => {
        let users = [...vaccineSelected];
        const user = users[userIndex];
        const group = user?.vaccines_groups[vgIndex];
        const vaccine = group?.vaccines[vaccineIndex];
        vaccine.isChecked = isChecked;

        if (user.age > 65 && group) {
            group.vaccines?.filter((t, index) => index != vaccineIndex).map(t => {
                t.isChecked = false;
            });
            group.isChecked = !!group?.vaccines?.find((t) => t.isChecked);
        }
        setVaccineSelected([...users]);

    }

    const handleUserInput = (e, selectedOptions, ci, vaccineOptionsCount, hasMultipleFluOptions) => {
        //console.log("handleUserInput", e, selectedOptions, ci);
        let so = selectedOptions;

        if (hasMultipleFluOptions && vaccineOptionsCount > 0 && selectedOptions?.length) {
            if (selectedOptions?.length === vaccineOptionsCount) {
                let highDoseFluIndex = so.findIndex(opt => { return (opt.value.toLowerCase().indexOf('flu') !== -1 && opt.value.toLowerCase().indexOf('high dose') !== -1) });
                if (highDoseFluIndex !== -1) {
                    so.splice(highDoseFluIndex, 1);
                }
            }
        }

        let tempVaccSelected = [...vaccineSelected];
        tempVaccSelected && tempVaccSelected.forEach((user, uindex) => {
            if (user.mrn === e.target.name) {
                user.vaccines_groups.forEach((groups, groupIndex) => {
                    groups.vaccines.forEach((vaccine, vIndex) => {
                        if (so.some((soi) => uindex === soi.userIndex && groupIndex === soi.vgIndex && soi.vaccineIndex === vIndex)) { vaccine.isChecked = true } else { vaccine.isChecked = false }
                    })
                });
            }
        })
        //console.log('tempVaccSelected---', tempVaccSelected)
        setVaccineSelected(tempVaccSelected);
    }

    const populateOptions = (users) => {
        let tempOptions = [];
        vaccineSelected && vaccineSelected.forEach((user, userIndex) => {
            if (user.mrn === users.mrn) {
                user.vaccines_groups.forEach((groups, vgIndex) => {
                    groups.vaccines.forEach((vaccine, vaccineIndex) => {
                        tempOptions.push({
                            label: vaccine.name,
                            value: vaccine.name,
                            userIndex: userIndex,
                            vgIndex: vgIndex,
                            vaccineIndex: vaccineIndex,
                        })
                    })
                })
            }

        });
        return tempOptions;
    }

    const hasMultipleFluOptions = (vaccinesGroup) => {
        let hasMultipleOptions = false;

        vaccinesGroup.forEach((groups, vgIndex) => {
            if (groups.group?.toLowerCase() === 'influenza' && groups.vaccines?.length > 1) {
                hasMultipleOptions = true;
            }
        })
        return hasMultipleOptions;
    }

    const selectedMemberList = (users) => {
        let tempOptions = [];
        userList && userList.forEach((user, userIndex) => {
            if (user.isChecked === true) {
                tempOptions.push(user)
            }
        });
        return tempOptions;
    }
    const selectedOptions = (users) => {
        let tempOptions = [];
        vaccineSelected && vaccineSelected.forEach((user, userIndex) => {
            if (user.mrn === users.mrn) {
                user.vaccines_groups.forEach((groups, vgIndex) => {
                    groups.vaccines.forEach((vaccine, vaccineIndex) => {
                        if (vaccine.isChecked === true) {
                            tempOptions.push({
                                label: vaccine.name,
                                value: vaccine.name,
                                userIndex: userIndex,
                                vgIndex: vgIndex,
                                vaccineIndex: vaccineIndex,
                            });

                        }
                    })
                })
            }

        });
        return tempOptions;
    }
    const disabledOptions = (users) => {
        let tempOptions = [];
        vaccineSelected && vaccineSelected.forEach((user, userIndex) => {
            if (user.mrn === users.mrn) {
                user.vaccines_groups.forEach((groups, vgIndex) => {
                    if (groups.group?.toLowerCase() === 'influenza' && groups.vaccines?.length > 1) {
                        let standardDoseFluIndex = groups.vaccines.findIndex(vac => { return (vac.name.toLowerCase().indexOf('high dose') === -1) });
                        let highDoseFluIndex = groups.vaccines.findIndex(vac => { return (vac.name.toLowerCase().indexOf('high dose') !== -1) });
                        let fluStandardDoseName = standardDoseFluIndex !== -1 ? groups.vaccines[standardDoseFluIndex].name : 'Flu Vaccine';
                        let fluHighDoseName = highDoseFluIndex !== -1 ? groups.vaccines[highDoseFluIndex].name : 'High Dose Flu Vaccine';

                        groups.vaccines.forEach((vaccine, vaccineIndex) => {
                            if (vaccine.isChecked === true && vaccine.name === fluStandardDoseName) {
                                tempOptions.push({
                                    label: fluHighDoseName,
                                    value: fluHighDoseName,
                                });

                            } else if (vaccine.isChecked === true && vaccine.name === fluHighDoseName) {
                                tempOptions.push({
                                    label: fluStandardDoseName,
                                    value: fluStandardDoseName,
                                });

                            }
                        })
                    }
                })
            }

        });
        return tempOptions;
    }
    const isUserBelowEighteen = () => {
        if (vaccineSelected?.find((user) => user.age >= 18 && !!user.vaccines_groups?.find(group => !!group.vaccines?.find(vac => vac.isChecked)))) {
            return false;
        }
        return !!vaccineSelected?.find((user) => {
            return user.age < 18
        })
    };
    const onClickConfirmed = () => {
        setShowModal(false);
        !isAddVaccineClicked && isUserBelowEighteen && isEnableNudge() ? history.push("/inhomeschedule/s41") : history.push("/inhomeschedule/s5")
    }

    const closeModal = () => {
        setShowModal(false);
    }
    const closeNudgeModal = () => {
        inHomeNudgeModalViewed();
        setShowModal(false);
        setIsNudge(false);
        setNudgeModal(true);
    }
    const noModalClicked = () => {
        inHomeNudgeModalViewed();
        setShowModal(false);
        setIsNudge(false);
        setNudgeModal(true);
        history.push("/inhomeschedule/s5");

    }
    const getSelectedVaccineCount = (users) => {
        let selectedLength = 0
        vaccineSelected && vaccineSelected.filter((user) => user.mrn === users.mrn).forEach(user => {
            user.vaccines_groups.forEach(groups => {
                let checkLength = groups.vaccines.filter(vaccine => vaccine.isChecked === true).length;
                selectedLength += checkLength;
            })

        });
        return selectedLength;
    }

    const getElligibleVaccineCount = (users) => {
        let selectedLength = 0
        vaccineSelected && vaccineSelected.filter((user) => user.mrn === users.mrn).forEach(user => {
            user.vaccines_groups.forEach(groups => {
                let checkLength = groups.vaccines.filter(vaccine => vaccine.name !== "").length;
                selectedLength += checkLength;
            })

        });
        return selectedLength;
    }

    const handleCheckAll = (users, isChecked) => {
        if (isChecked) {
            let tempCheckAll = checkAllMRN.filter(mrn => users.mrn !== mrn);
            //console.log('tempCheckAll', tempCheckAll)
            setCheckAllMRN([...tempCheckAll])
        } else {
            let tempCheckAll = [...checkAllMRN, users.mrn]
            //console.log('tempCheckAll', tempCheckAll)
            setCheckAllMRN([...tempCheckAll])
        }
        //let tempVaccSelected = [...vaccineSelected];
        //tempVaccSelected && tempVaccSelected.forEach(user => {
        //    if (user.mrn === users.mrn) {
        //        user.vaccines_groups.forEach(groups => {
        //            groups.vaccines.filter(vaccine => vaccine.isChecked = !isChecked)
        //        })
        //    }
        //});
        //console.log('tempVaccSelected---', tempVaccSelected)
        //setVaccineSelected(tempVaccSelected);

    }


    //event handler for 'select all' checkbox on Users List
    const handleUsersCheckAll = (isChecked) => {

        setisAllUsersChecked(isChecked);
        let allSelectedUsers = userList.map((user) => ({
            ...user,
            isChecked: isChecked,
        }));
        setUserList(allSelectedUsers);
        //console.log("isChecked, allSelectedUsers", isChecked, allSelectedUsers);  
    }


    const isAllChecked = (mrn) => {
        if (checkAllMRN.indexOf(mrn) > -1) {
            return true;
        }
        else {
            return false;
        }
    }

    const handleUserCheck = (e) => {
        let tempUsers = [...userList];
        tempUsers.forEach((tempUser, index) => {
            if (e.target.value.some((selectedUs) => selectedUs.patientName === tempUser.patientName)) {
                tempUser.isChecked = true
            }
            else {
                tempUser.isChecked = false
            }
        })
        setUserList(tempUsers);
        setisAllUsersChecked(false);

    }


    const accordionClick = (userIndex) => {
        if (activeAccordionIndex === userIndex) {
            setActiveAccordionIndex(-1);
        }
        else {
            setActiveAccordionIndex(userIndex);
            setShowMembers(false);
        }
    }


    const hasMoreUsersToAdd = () => {
        let hasUsersToAdd = userList?.some(u => (!u.hasOwnProperty('isChecked')) || (u.hasOwnProperty('isChecked') && u.isChecked === false));
        //console.log("userList, HasmoreUsersToAdd ", userList, hasUsersToAdd);
        return hasUsersToAdd;
    }

    const areAllUsersSelected = () => {
        let eligibleUsers = profileList?.filter(prof => prof?.features?.find((feature) => feature.key === "inHomeVaccination")) ;
        // userList?.some(u => (!u.hasOwnProperty('isChecked')) || (u.hasOwnProperty('isChecked') && u.isChecked === false));
        //console.log("eligibleUsers ", eligibleUsers);
        //console.log("selectedUsers", selectedUsers);
        return eligibleUsers?.length == selectedUsers?.length;
    }


    const closeVaccineErrorsModal = () => {
        setShowVaccineErrors(false);
    }
    const cancelBooking = () => {
        setShowVaccineErrors(false);
        history.push("/")
    }
    const renderVaccineErrorMessages = () => {

        return <Modal
            isOpen={showVaccineErrors}
            //onCloseClick={closeVaccineErrorsModal}
            //className="inhome-modal"
            modalHeader={<>
                {getVaccineResult.errorMsg === inHomeWhereErrors.noVax ?
                    "There are no vaccine appointments available at this time." :
                    getVaccineResult.errorMsg === inHomeWhereErrors.notInServiceArea ?
                        "In-home vaccinations are not available in this area." :
                        getVaccineResult.errorMsg === inHomeWhereErrors.notValidZip ?
                            "Incorrect ZIP Code"
                            :
                            "Oops, something went wrong."
                }
            </>}
            modalBody={<>
                {getVaccineResult.errorMsg === inHomeWhereErrors.noVax ?
                    "You can change your location or come back later and try again." :
                    getVaccineResult.errorMsg === inHomeWhereErrors.notInServiceArea ?
                        "You can try a different zip code or check back again later. We’ll be expanding our service area soon." :
                        getVaccineResult.errorMsg === inHomeWhereErrors.notValidZip ?
                            `The ZIP code you entered is not valid for ${locationInfo.city.toUpperCase()}. Please try again.`
                            :
                            "Please try again later if the issue persists." || `${getVaccineResult?.errorMsg}`
                }
            </>}
            modalFooterButtons={
                getVaccineResult.errorMsg === inHomeWhereErrors.noVax || getVaccineResult.errorMsg === inHomeWhereErrors.notInServiceArea ?
                    [{ label: "Update location", onClick: closeVaccineErrorsModal },
                        { label: "Cancel booking", onClick: cancelBooking }]
                    :
                    [{ label: getVaccineResult.errorMsg === inHomeWhereErrors.notValidZip ? 'Try again' : 'Okay', onClick: closeVaccineErrorsModal }]
            }
        />
    }

    const renderBelowEighteenWarnings = () => {
        if (!showModal) return;
        return <Modal
            isOpen={true}
            //onCloseClick={closeModal}
            //className="inhome-modal"
            modalHeader="Must be present notice"
            modalBody="A parent or legal guardian must be present on the day of a appointment to receive these vaccinations."
            modalFooterButtons={
                [{ label: "I understand", onClick: onClickConfirmed }]
            }
        />
    }

    const renderNudgeWarnings = () => {
        if (!isNudge) return;
        return <Modal
            isOpen={true}
            //onCloseClick={closeNudgeModal}
            //className="inhome-modal"
            modalHeader="Did you know?"
            modalBody={<>
                <p>Getting multiple vaccines at the same time is both the safest and the most effective method to prevent disease and serious illness.</p>
                <p>Would you like to add any other vaccines to this appointment?</p>
            </>}
            modalFooterButtons={
                    [{ label: "No, thank you", onClick: noModalClicked },
                    { label: "Yes, I would", onClick: closeNudgeModal }]
            }
        />
    }
    const isMobileSize = (screenBreakPoint === msgs.XS_MOBILE || screenBreakPoint === msgs.SM_MOBILE || screenBreakPoint === msgs.MD_TABLET || screenBreakPoint === msgs.LG_TABLET || screenBreakPoint === msgs.XL_DESKTOP) ? true : false;

    return (
        <>
            {renderBelowEighteenWarnings()}
            {!nudgeModal ? renderNudgeWarnings() : null}
            {showVaccineErrors && renderVaccineErrorMessages()}


            {!serviceLocation ? <Redirect to='/inhomeschedule/s31' /> :
                <>
                    <InHomeSplitLayout
                        className="inhome-scheduling-which-container"
                        progressPercent={4 / 7 * 100}
                    >
                        <InHomeMainPanel
                            heading="Which vaccinations would you like to receive?"
                            subheading="Note: For the Influenza Vaccine, patients 65+ can select the Standard-Dose or the recommended High-Dose."
                            schedulingButtons={{
                                disabledNext: isNextButtonDisabled(),
                                leftOnClick: onClickPrev,
                                rightOnClick: onClickNext
                            }}
                        >
                            <div className="row">
                                <div className="col-12 col-lg-10 which-detail-wrapper">
                                    {getVaccinePending && <Spinner />}
                                    <div className="add-family-member-div">
                                        <DropDown
                                            label="Add a family member"
                                            options={userList}
                                            id="selectedMonths"
                                            name="selectedMonths"
                                            onChange={(e, changedItem) => { handleUserCheck(e); }}
                                            //onSelectAllClick={(e) => { handleUsersCheckAll(true) }}
                                            multiselect
                                            showSelectAll
                                            selectedOptions={selectedMemberList()}
                                            disabled={areAllUsersSelected()}
                                        />
                                    </div>
                                    <Divider mTop="none" mBottom="none" mLeft="none" mRight="none" />
                                    <div className="vaccine-selection-div">
                                        {vaccineSelected && vaccineSelected.map((user, userIndex) => {
                                            let vaccineOptions = [];
                                            let userHasMultipleFluOptions = false;
                                            let vaccineOptionsCount = 0;
                                            if (user.vaccines_groups?.length && user.vaccines_groups?.length > 0) {
                                                vaccineOptions = populateOptions(user);
                                                userHasMultipleFluOptions = hasMultipleFluOptions(user.vaccines_groups);
                                                vaccineOptionsCount = vaccineOptions?.length && vaccineOptions?.length > 0 ? vaccineOptions?.length : 0;
                                            }

                                            return (
                                                <InHomePatientInputSection
                                                    key={`user-${userIndex}`}
                                                    patientName={`${user.patientName} (${user.dob})`}
                                                    subText={(user.vaccines_groups?.length && user.vaccines_groups?.length > 0)
                                                        ? user.notes?.map((note, noteIndex) => {
                                                            return (
                                                                <div key={`note-${noteIndex}`}>
                                                                    <strong>NOTE:</strong> {note.note}
                                                                </div>
                                                            )
                                                        })
                                                        : ''
                                                    }
                                                >
                                                    {(user.vaccines_groups?.length && user.vaccines_groups?.length > 0)
                                                        ? <DropDown
                                                            label="Vaccines"
                                                            options={vaccineOptions}
                                                            onChange={(e, selectedOptions, changedItem) => { handleUserInput(e, selectedOptions, changedItem, vaccineOptionsCount, userHasMultipleFluOptions); }}
                                                            onSelectAllClick={(e) => { handleCheckAll(user, isAllChecked(user.mrn)) }}
                                                            onDeselectAllClick={(e) => { handleCheckAll(user, isAllChecked(user.mrn)) }}
                                                            id={user.mrn}
                                                            name={user.mrn}
                                                            required
                                                            multiselect
                                                            multiselectCount={userHasMultipleFluOptions && vaccineOptionsCount > 0 ? (vaccineOptionsCount - 1) : undefined}
                                                            showSelectAll
                                                            selectedOptions={selectedOptions(user)}
                                                            disabledOptions={userHasMultipleFluOptions ? disabledOptions(user) : undefined}
                                                            errorMsg="Please select a vaccine"
                                                        />
                                                        : <Card className="recipient-noVaccine-msg"><Typography type="body-02">No vaccines available</Typography></Card>
                                                    }
                                                </InHomePatientInputSection>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                        </InHomeMainPanel>

                        <InHomeConfirmationModal />

                        <InHomeOverviewPanel vaccinesPhase={true} />
                    </InHomeSplitLayout>
                </>
            }</>
    );
}
const mapStateToProps = state => {
    const selectedUsers = state.inHome?.selectedUsers;
    const vaccinesDetails = state.inHome.getVaccineResult;
    const vaccinesData = vaccinesDetails?.data || [];
    const usersAndVaccines = [];
    const selectedVaccines = cloneDeep(state.inHome.selectedVaccines);


    if (vaccinesData.length > 0) {
        selectedUsers?.map((user) => {
            let patientName = user.patientName;
            let mrn = user.mrn;
            let dob = user.dob

            const extractUser = vaccinesData.find((vax) => { return vax.mrn === mrn });

            usersAndVaccines.push({ patientName, mrn, dob, ...extractUser });
        })
    }

    return {
        serviceLocation: state.inHome.serviceLocationContactInfo,
        eligibleVaccines: usersAndVaccines,
        selectedVaccines: selectedVaccines,
        selectedUsers: state.inHome?.selectedUsers,
        getVaccinePending: state.inHome?.getVaccinePending,
        getVaccineResult: state.inHome?.getVaccineResult,
        profileList: state.memberships.profileList,
        screenBreakPoint: state.common.screenBreakPoint,
        vaccineNudgeClicked: state.inHome.vaccineNudgeClicked,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setSelectedVaccines: (data) => {
            dispatch({ type: types.SET_INHOME_VACCINES, data })
        },
        getAvailableVaccines: () => {
            dispatch({ type: types.GET_INHOME_VACCINES })
        },
        getPrefilledData: (selectedUsers) => {
            dispatch({ type: types.CHECK_GET_INHOME_PREFILL, selectedUsers });
        },
        setSelectedUsers: (users) => { dispatch({ type: types.SET_SELECTED_USERS, selectedUsers: users }) },
        inHomeNudgeModalViewed: () => {
            dispatch({ type: types.INHOME_NUDGE_MODAL_VIEWED })
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(InHomeWhich);